import { Box, BoxProps, Link, Typography } from "@mui/material";
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import { NavigateNext } from "@mui/icons-material";
import { styled } from "@mui/material";
import { forwardRef } from "react";
import ReactGA from "components/ReactGA";

const BoxBreadcrumbs = styled(Link)(() => ({
  textDecorationColor: "#a6c4a9",
  fontSize: "0.875rem",
  cursor: "pointer",
  width: "20px",
}));

/**
 *
 * @param {array} items {text:"",handleChangeTo:func}
 *
 */

const Breadcrumb = ({ children }) => {
  return (
    <MuiBreadcrumbs separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb">
      {children}
    </MuiBreadcrumbs>
  );
};

export type BreadcrumbsPageProps = {
  items: {
    handleChangeTo: () => any;
    text: string;
    key?: string;
    href?: string;
  }[];
};
const Breadcrumbs = ({ items }: BreadcrumbsPageProps) => {
  return (
    <>
      <Breadcrumb>
        {items &&
          items.map((e, i) =>
            e?.handleChangeTo || e?.href ? (
              <BoxBreadcrumbs
                key={i}
                id={`breadcrumbs-link-${i}`}
                href={e?.href || "#"}
                onClick={() => {
                  e?.href &&
                    ReactGA.event("click_navigation", {
                      component: "breadcrumbs",
                      link: e.key,
                    });
                  e?.handleChangeTo && e.handleChangeTo();
                }}
              >
                {e.text}
              </BoxBreadcrumbs>
            ) : (
              <Typography
                key={i}
                id={`breadcrumbs-link-${i}`}
                variant="body3"
                color="text.secondary"
              >
                {e.text}
              </Typography>
            )
          )}
      </Breadcrumb>
    </>
  );
};

export default Breadcrumbs;
